import React from 'react'
import { connect } from 'react-redux'
import Chats from './Chats'
import Typing from './Typing'
import Loading from '../Loading'
import Alert from '../Alert'
//import 'emoji-picker-element';
import {
    ajaxNewChatVC,
    ajaxTyping,
    getChatStatus,
    getRequestedVia,
    secondsToDhms,
    setTimerInterval,
    warnNoChat,
    warnUserDidntRequestedChat
} from '../redux/FeedbackRedux'
import ChatAttachmentPreview from './ChatAttachmentPreview'
import { buildAttachment, showAttachmentError, validateAttachment } from './chatAttachmentUtils'

// Unique per instance: FeedbackDetail mounts ChatSection 3x (desktop/mobile/print),
// so a shared input id would make the label target the wrong (hidden) instance.
let chatAttachmentInputSeq = 0;

class ChatSection extends React.Component {

    constructor(props) {
        super(props);
        const id = this.props.feedback_id;
        this.attachmentInputId = `feedback_attachment_${++chatAttachmentInputSeq}`;
        this.state = {
            value: '',
            initial_feedback: id,
            cleared: false,
            last_typing: Math.floor(Date.now() / 1000),
            sent_first: false,
            timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted(),
            attachments: []
        };
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.handleAttachmentChange = this.handleAttachmentChange.bind(this);
        this.handleRemoveAttachment = this.handleRemoveAttachment.bind(this);
        this.resetAttachments = this.resetAttachments.bind(this);
    }

    handleTimeSinceFeedBackStarted()
    {
        if (!this.props.feedback.timeStart) return "";
        const startDate = new Date(this.props.feedback.timeStart.replace(/\s/g, 'T') + "Z");
        const endDate = new Date();
        const seconds = (+endDate - +startDate) / 1000;

        return secondsToDhms(seconds, false, true);
    }

    // RTF-4374: the authenticated user's "may send a chat" permission, read from
    // the serialized Auth::user() exposed on the feedback detail page. Treat a
    // missing attribute as permitted to preserve legacy behavior.
    canSendChat()
    {
        return window.currentUser?.can_send_chat !== false;
    }

    handleChange(event) {
        this.setState(
            {value: event.target.value}
        );
        if (this.state.cleared != false) {
            this.setState({
                cleared: false,
            });
        }
        var now = Math.floor(Date.now() / 1000);
        if (this.state.sent_first == true) {
            if (now > (this.state.last_typing + 2)) {
                this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
                this.setState(
                    {last_typing: now}
                );
            }
        } else {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
            this.setState(
                {last_typing: now, sent_first: true}
            );
        }
    }

    // window.chatAttachments is the buffer ajaxNewChatVC sends from.
    handleAttachmentChange(event) {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) {
            return;
        }

        const accepted = [];
        files.forEach((file) => {
            const error = validateAttachment(file);
            if (error) {
                showAttachmentError(error);
                return;
            }
            accepted.push(buildAttachment(file));
        });

        // Reset so re-selecting the same file fires change again.
        event.target.value = '';

        // Skip files already attached.
        window.chatAttachments = window.chatAttachments || [];
        const existingKeys = new Set([
            ...this.state.attachments.map((attachment) => attachment.key),
            ...window.chatAttachments.map((item) => item.key)
        ]);
        const unique = accepted.filter((attachment) => {
            if (existingKeys.has(attachment.key)) {
                if (attachment.previewUrl) {
                    URL.revokeObjectURL(attachment.previewUrl);
                }
                return false;
            }
            existingKeys.add(attachment.key);
            return true;
        });

        if (unique.length === 0) {
            return;
        }

        unique.forEach((attachment) => {
            window.chatAttachments.push({ key: attachment.key, obj: attachment.file });
        });

        this.setState((prevState) => ({
            attachments: [...prevState.attachments, ...unique]
        }));
    }

    handleRemoveAttachment(key) {
        this.setState((prevState) => ({
            attachments: prevState.attachments.filter((attachment) => {
                if (attachment.key === key && attachment.previewUrl) {
                    URL.revokeObjectURL(attachment.previewUrl);
                }
                return attachment.key !== key;
            })
        }));

        window.chatAttachments = (window.chatAttachments || []).filter((item) => item.key !== key);
    }

    // No setState — safe to call from componentWillUnmount.
    revokeAttachmentUrls() {
        this.state.attachments.forEach((attachment) => {
            if (attachment.previewUrl) {
                URL.revokeObjectURL(attachment.previewUrl);
            }
        });
    }

    resetAttachments() {
        this.revokeAttachmentUrls();
        window.chatAttachments = [];
        this.setState({ attachments: [] });
    }

    handleEmojiClick(event) {
        // var v = this.state.value;
        // this.setState(
        //     {value: v + event.detail.unicode}
        // );
        // if(this.state.cleared != false) {
        //     this.setState({
        //         cleared: false,
        //       });
        // }
        // if(event.detail){
        //     jQuery('.emoji-dropdown.show, .emoji-dropdown .show').removeClass('show');
        // }
        return true;
    }

    handleClick(event) {
        // RTF-4374: server also rejects with 403, but short-circuit here to avoid the request.
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        if (this.props.loading === false && (this.state.value !== '' || (window.chatAttachments && window.chatAttachments.length > 0))) {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, false));
            this.props.dispatch(ajaxNewChatVC(this.state.value, this.props.feedback.feedback_id));
            this.resetAttachments();
        }
        this.setState({value: ''});
    }

    handleClickMobile(event) {
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        if(this.props.loading == false && (this.state.value != '' || (window.chatAttachments && window.chatAttachments.length > 0))) {
                this.props.dispatch(ajaxNewChatVC(this.state.value, this.props.feedback.feedback_id));
                this.resetAttachments();
        }
        this.setState(
            {value: ''}
        );
    }

    handleTextClick(event) {
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone))
        {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        if(event.target.value == "") {
            this.setState(
                {value: ''}
            );
        }
    }

    handlePreCanned(event) {
        event.preventDefault();
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        var data = jQuery(event.target).attr('data-text');
        var target = jQuery(event.target);
        this.setState(
            {value: data}, ()=>{
                jQuery("#chat-textarea").trigger("input");
            }
        );


    }

    handleReview(event) {
        event.preventDefault();
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        let data = jQuery(event.target).attr('data-text');
        this.setState(
            {value: data},
            ()=>{
                jQuery("#chat-textarea").trigger("input");
            }
        );
    }

    handleReviewOnly(event) {
        event.preventDefault();
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        var data = jQuery("#chat-textarea").val() + " " + jQuery(event.target).attr('data-text');
        console.log(data);
        data = data.replace(/\s+/g,' ').trim();
        this.setState(
            {value: data},
            ()=>{
                jQuery("#chat-textarea").trigger("input");
            }
        );
    }

    handleGpsRequest(event) {
        event.preventDefault();
        if (!this.canSendChat()) return;
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
            return;
        }
        var data = jQuery(event.target).attr('data-text');
        this.setState(
            {value: data},
            ()=>{
                jQuery("#chat-textarea").trigger("input");
            }
        );
    }

    handleChatType(event) {
        if (!this.props.feedback.is_text && !this.props.feedback.is_whatsapp && this.props.feedback.user.phone) {
            if (!this.props.chatAnyway) {
                warnUserDidntRequestedChat(this.props.dispatch);
            }
        }
    }

    componentDidUpdate() {
        if (this.state.initial_feedback != this.props.feedback_id && this.state.cleared == false) {
            // Redux clears window.chatAttachments on feedback switch; keep chips in lockstep.
            this.revokeAttachmentUrls();
            window.chatAttachments = [];
            this.setState({
                value: "",
                initial_feedback: this.props.feedback_id,
                cleared: true,
                attachments: [],
            });
        }
    }

    componentWillUnmount() {
        this.revokeAttachmentUrls();
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    componentDidMount() {
        this.props.dispatch(setTimerInterval());
        // if(document.querySelector('emoji-picker')){
        //     document.querySelector('emoji-picker').addEventListener('emoji-click', event => this.handleEmojiClick(event));
        //     $('.emoji-dropdown .dropdown-menu *').click(function(e) {
        //         e.stopPropagation();
        //     });
        // }
        setInterval(() => {
            this.setState({timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted() })
        }, 1000)
    }

    render() {

        const {chat_alert, chat_button_text} = getChatStatus(this.props.feedback);
        // RTF-4374: admin may have revoked this user's ability to send chats.
        const canSendChat = this.canSendChat();

        return (
            <div className="card-body chat border-topx" id="chatsection">
            <div className="row">
                <div className="col-md-12">
                <h5 id="chat" className="d-inline">Chat:</h5>
                {this.props.feedback.response_time?<h6 className="text-muted">{ __('Response time') }: {this.props.feedback.response_time}</h6>:null}
                    {((this.props.feedback.chat_status === "Chat Not Started" && this.props.feedback.is_include_contact && this.props.feedback.user.phone && (this.props.feedback.is_whatsapp || this.props.feedback.is_text)) ?
                        <h6 className="chat-alert-message"><i className="fas fa-exclamation-triangle text-warning mr-1"></i>{this.props.feedback.chat_status}&nbsp;({this.state.timeSinceFeedBackStarted} { __('since Feedback submitted') })</h6> : "")}
                    {(!this.props.feedback.is_text && !this.props.feedback.is_whatsapp && this.props.feedback.user.phone) &&
                        <span className={this.props.feedback.otf_id ? "font-weight-bold" : null}>( { __('This customer did not request a response via chat')}. {getRequestedVia(this.props.feedback)} )</span>
                    }
                </div>
            </div>


            <div className="row">
            {this.props.feedback.chats.length > 0 &&
                    <div className="col-md-12">
                        <div className="border pb-4 pt-4 pl-2 pr-3 pl-sm-0 pr-sm-0 chat_widget" id="chat_widget">
                        {( this.props.current_user && (typeof this.props.feedback.include_user_details == "undefined" || this.props.feedback.include_user_details != false) ) &&
                            <Chats />
                        }
                        {( !this.props.current_user || !(typeof this.props.feedback.include_user_details == "undefined" || this.props.feedback.include_user_details == false) ) &&
                            <Chats hidename={true}/>
                        }
                        <Typing />
                        </div>
                    </div>
            }

                {/* RTF-4374: show a notice when the user cannot send chats */}
                {(this.props.current_user && !canSendChat) &&
                    <div className="col-md-12 mt-3">
                        <p className="text-muted font-italic mb-0">{__('Your ability to send chats has been disabled')}</p>
                    </div>
                }

                {(this.props.current_user && canSendChat) &&
                    <div className="col-md-12 mt-3 overflow-hidden">
                        <Loading location={'chat'}/>
                        <div className="input-group feedback-form-control mb-0 border">
                            <div
                                className={"input-group-prepend prepend-textarea" + (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone) || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1) ? " readonly" : "")}>
                                <span className="input-group-text"><i className="fas fa-comments"></i></span>
                            </div>
                            <textarea
                                onChange={this.handleChange.bind(this)}
                                onKeyUp={this.handleChatType.bind(this)}
                                onClick={this.handleTextClick.bind(this)}
                                id="chat-textarea"
                                value={this.state.value}
                                className={"form-control placeholder-up textarea pl-0"}
                                placeholder={(this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1) ? __("Whatsapp's regulations require the user to respond before another message can be sent.") : __("Type your message") + '...'}
                                aria-label={__("Type your message") + '...'}
                                readOnly={((!(this.props.feedback.is_include_contact && this.props.feedback.user.phone) || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1)) ? "readOnly" : false)}></textarea>
                        </div>
                        <div className="text-right" id="feedback_attachment_div">
                            <ChatAttachmentPreview attachments={this.state.attachments} onRemove={this.handleRemoveAttachment} />
                            <input type="file" className="feedback_attachment" multiple name="feedback_attachment[]"
                                   id={this.attachmentInputId}
                                   onChange={this.handleAttachmentChange}
                                   accept="image/png, image/jpeg, image/*, video/mp4, video/quicktime, video/H264, video/mpeg, video/webm, application/pdf"/>
                        </div>
                    </div>
                }
                <div className="col-sm-12 mt-2 mb-2">
                <Alert alert={this.props.alert} location={'chat'} />
                </div>
                {(this.props.current_user && canSendChat) &&
                <div className="col-sm-12 text-right d-none d-sm-flex justify-content-end">
                    <label htmlFor={this.attachmentInputId} id="feedback_attachment_label" className="btn btn-sm btn-outline-secondary mr-2 mb-0 bg-white">
                        <i className="fas fa-cloud-upload-alt"></i>&nbsp;{__('Attach file(s) to your message')}
                    </label>
                    { (this.props.feedback.business.rating_request == 1) &&

                        <button className="btn btn-sm btn-outline-secondary mr-2 mb-0" data-text={this.props.feedback.business.rating_request_text + ' ' + this.props.feedback.otf_url} onClick={this.handleReview.bind(this)} type="button">{ __('Insert Rating Request') }</button>
                    }
                         { this.props.feedback.allow_gps_feedback &&
                        <button className="btn btn-sm btn-outline-secondary mr-2" data-text={"Send us GPS coordinates at https://"+this.props.feedback.friendly_access_url+"/gps/"+this.props.feedback.short_id} onClick={this.handleGpsRequest.bind(this)} type="button"><i className="fas fa-globe mr-1"></i> { __('Request GPS Coordinates') }</button>
                        }


                        {/* <div className="dropdown emoji-dropdown">
                            <button className="btn btn-sm btn-outline-secondary mr-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Emojis
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                            <div className="dropdown-item bg-white"><emoji-picker></emoji-picker></div>
                            </div>
                        </div> */}


                        <div className="dropdown">
                            <button className="btn btn-sm btn-outline-secondary mr-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            { __('Send Pre-canned Response') }
                            </button>
                                {this.props.feedback.business.precanned && this.props.feedback.business.precanned.length >= 1 &&
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {this.props.feedback.business.precanned.map((value,index) => {
                                            return <a className="dropdown-item text-capitalize" key={index} onClick={this.handlePreCanned.bind(this)} data-text={value.text} href="#">{value.label}</a>
                                        })}
                                    </div>
                                }
                                {this.props.feedback.business.precanned < 1 &&
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a className="dropdown-item">{ __('None') }</a>
                                    </div>
                                }
                        </div>

                    <button className={this.props.loading?"disabled btn btn-sm btn-primary":("btn btn-sm"+(!(this.props.feedback.is_include_contact && this.props.feedback.user.phone) || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1) ?" btn-secondary":" btn-primary"))} onClick={this.handleClick.bind(this)} type="button"><i className="fas fa-paper-plane ml-1 mr-1"></i> { __('Send') }</button>
                </div>
                }
                {(this.props.current_user && canSendChat) &&
                <div className="col-sm-12 text-right d-block d-sm-none">
                    { (this.props.feedback.business.rating_request == 1) &&
                                <button className="btn btn-sm btn-outline-secondary mr-2 mb-0" data-text={this.props.feedback.business.social_media === null ? "" : this.props.feedback.business.social_media.description + " https://ratethisbiz.com/"+this.props.feedback.short_id} onClick={this.handleReview.bind(this)} type="button">{ __('Insert Rating Request') }</button>
                    }
                        { this.props.feedback.allow_gps_feedback &&
                         <div>
                        <button className="btn btn-sm btn-outline-secondary mt-1" data-text={"Please share your GPS Location by clicking https://"+this.props.feedback.friendly_access_url+"/gps/"+this.props.feedback.short_id} onClick={this.handleGpsRequest.bind(this)} type="button"><i className="fas fa-globe mr-1"></i> { __('Request GPS Coordinates') }</button>
                        </div>
                        }

                        <div className="dropdown mb-2">
                            <button className="btn btn-sm btn-outline-secondary mr-sm-2 mt-1 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                { __('Send Pre-canned Response') }
                            </button>
                                {this.props.feedback.business.precanned && this.props.feedback.business.precanned.length >= 1 &&
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {this.props.feedback.business.precanned.map((value,index) => {
                                            return <a className="dropdown-item text-capitalize" key={index} onClick={this.handlePreCanned.bind(this)} data-text={value.text} href="#">{value.label}</a>
                                        })}
                                    </div>
                                }
                                {this.props.feedback.business.precanned < 1 &&
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item">{ __('None') }</a>
                                </div>
                                }
                        </div>
                        <button className={this.props.loading ? "disabled btn btn-sm btn-primary mt-1":"btn btn-sm btn-primary mt-1"} onClick={this.handleClickMobile.bind(this)} type="button"><i className="fas fa-paper-plane mr-1"></i> { __('Send') }</button>
                </div>
                }
            </div>

        </div>

        );
    }

}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        loading: state.loading,
        feedback_id: state.selected_feedback,
        alert: state.alert,
        current_user: state.current_user,
        chatAnyway: state.chatAnyway
    }
}

export default connect(mapStateToProps)(ChatSection);
